import { Directive, HostBinding, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[animateFade]',
  standalone: true,
})
export class AnimateFadeDirective implements OnChanges {
  @Input('animateFade') @HostBinding('attr.data-shown') shown = false;

  private direction: 'left' | 'right' | 'bottom' | undefined;
  private previousShown: boolean | undefined;
  private hasToggled = false;

  private readonly animationBase = `
  data-[shown=true]:animate-in data-[shown=true]:fade-in 
  data-[shown=false]:animate-out data-[shown=false]:fade-out
  fill-mode-forwards`;

  private readonly animations = {
    left: `
    data-[shown=true]:slide-in-from-left-2
    data-[shown=false]:slide-out-to-left-2
    `,
    right: `
    data-[shown=true]:slide-in-from-right-2
    data-[shown=false]:slide-out-to-right-2
    `,
    bottom: `
    data-[shown=true]:slide-in-from-bottom-2
    data-[shown=false]:slide-out-to-bottom-2
    `,
  };

  ngOnChanges(): void {
    if (this.previousShown !== undefined && this.previousShown !== this.shown) {
      this.hasToggled = true;
    }
    this.previousShown = this.shown;
  }

  @HostBinding('class') get classList(): string {
    // An element keeps its initial state without animation until it is toggled: a shown one has nothing to animate
    // from, a hidden one is hidden by plain styles, since an instant exit animation did not hold on a full page load.
    if (!this.hasToggled) {
      return this.shown ? '' : 'invisible opacity-0';
    }

    return [this.animationBase, ...(this.direction ? [this.animations[this.direction]] : [])].join(' ');
  }

  @Input() set animateDirection(direction: 'left' | 'right' | 'bottom' | undefined) {
    this.direction = direction;
  }
}
